<template>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="top-banner-box">
                <div class="map-legend map-classical-row-legend-flex">
                    <div class="d-flex flex-wrap p-4">
                        <div class="p-3" v-for="(legend, index) in mapLegends" :key="index">
                            <span
                                class="legend-circle"
                                :style="{ backgroundColor: legend.colour }"
                            ></span>
                            {{ legend.name }}
                        </div>
                    </div>
                </div>
                <BaseMap
                    v-if="showMap && mode === 'map'"
                    type="satellite"
                    class="h-full"
                    @map-loaded="onMapLoaded"
                />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-7 col-xl-12 roman-map-classical-container">
            <div class="inner-box">
                <div class="inner-content">
                    <div class="banner-box">
                        <img class="rounded-4 h-400 img-row-feedback" :src="sampleGroup.main_image.url" />
                    </div>
                    <h4 class="mt-4"><b>{{ sampleGroup.heading }}</b></h4>

                    <div v-if="closestSampleInfo" class="result-map-bar my-3 p-4 rounded-4">
                        <div class="row w-100">
                            <div class="col-2">
                                <p>Closest Sample</p>
                                <h4 class="d-flex text-start"><b>{{ closestSampleInfo.properties.id }}</b></h4>
                            </div>
                            <div class="col-6">
                                <p>Location</p>
                                <h4 class="d-flex text-start">
                                    <b>{{ closestSampleInfo.properties.location }}</b>
                                </h4>
                            </div>
                            <div class="col-2">
                                <p>Time Zone</p>
                                <h4 class="d-flex text-start"><b>{{ closestSampleInfo.properties.date }}</b></h4>
                            </div>
                            <div class="col-2 d-flex align-items-center">
                                <button v-if="!hasZoomed" @click="zoom" class="load-btn m-auto">
                                    <FeatherWrapper icon="zoom-in" />
                                    <span>Zoom on Map</span>
                                </button>
                                <button v-else @click="resetZoom" class="load-btn m-auto">
                                    <FeatherWrapper icon="zoom-out" />
                                    <span>Reset</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="sampleGroup" v-html="sampleGroup.text" />
                    <!-- <h6 class="mb-3"><b> Time range of Samples: 604 - 153 BCE </b></h6>
                    <p>
                        This geographic region covers parts of present day southern Spain and
                        France.
                    </p>
                    <p>
                        The oldest city of modern France is the port city of Marseille. It was
                        founded by Greeks from the Asia Minor around 600 BCE as a trading colony,
                        named Massalia. Remains of the Greek harbour in the Jardin des Vestiges can
                        be found in central Marseille. From Massalia, maritime trade developed with
                        other Greek trading ports and settlements in the Mediterranean including the
                        Greek city of Emporiae on the coast of Spain. Excavations confirm that
                        Phoenician Greeks had settled in southern Spain after 800 BCE, shortly after
                        the founding of the greatest Phoenician colony, Carthage (now in Tunisia).
                        Empúries was one such city on the Mediterranean coast of Spain and was
                        founded in 575 BCE - the meaning of the city's name is "trading place".
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { inject, ref, defineProps } from "vue";
import BaseMap from "@/components/Maps/BaseMap.vue";
// import Sidebar from "@/components/Sidebar.vue";
import {
    attachClassicalShapesToMap,
    attachClassicalSitesToMap,
    zoomToGroup,
} from "@/view/ancestry/recent/mapHelpers";
// import MobileContent from "@/components/ancestry/MobileContent.vue";
// import ClosestSample from "@/components/Classical/ClosestSample.vue";
// import MapLegend from "@/components/MapLegend.vue";
import { getClassicalColour } from "@/composables/useClassicalContent";

const props = defineProps({
    introduction: Object,
    sampleGroup: Object,
    sampleSites: Object,
});

const showMap = ref(false);
const mode = ref("map");
const mapRef = ref({});
const hasZoomed = ref(false);
const result = inject("greek-result");
const closestSampleInfo = ref(null);

const mapLegends = [
    { name: "Closest sample site", colour: "hsl(141,96%,37%)", type: "site" },
    {
        name: `Other ${props?.sampleGroup?.heading} sites`,
        colour: getClassicalColour("greek"),
        type: "site",
    },
    {
        name: `${props?.sampleGroup?.heading} geographical area`,
        colour: getClassicalColour("greek"),
        type: "main-area",
    },
    {
        name: `Greek Empire`,
        colour: getClassicalColour("greek"),
        type: "area",
    },
    {
        name: `Other greek sites`,
        colour: "#ccc",
        type: "site",
    },
];

setTimeout(() => {
    showMap.value = true;
});
function zoom() {
    window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
    });
    hasZoomed.value = true;
    const [sampleGroupFeature] = JSON.parse(props?.sampleGroup?.plain_text).features;
    zoomToGroup(mapRef.value, sampleGroupFeature);
}

function resetZoom() {
    hasZoomed.value = false;
    const [feature] = JSON.parse(props?.introduction?.plain_text).features;
    zoomToGroup(mapRef.value, feature);
}

function onMapLoaded(map) {
    mapRef.value = map;

    const sites = JSON.parse(props?.sampleSites?.plain_text).features;
    const [feature] = JSON.parse(props?.introduction?.plain_text).features;
    const [sampleGroupFeature] = JSON.parse(props?.sampleGroup?.plain_text).features;

    attachClassicalShapesToMap(map, {
        people: "greek",
        feature,
        type: "main",
    });

    attachClassicalShapesToMap(map, {
        people: "greek",
        feature: sampleGroupFeature,
        type: "sampleGroup",
    });

    zoomToGroup(map, feature);

    const siteInfo = attachClassicalSitesToMap(map, {
        sites,
        people: "greek",
        closestSample: result?.greeks?.closest_sample,
    });

    closestSampleInfo.value = siteInfo.pop();
}
</script>
